module.exports = __webpack_public_path__ + "img/cut4icon.708d7262.png";